import React from 'react'
import { Icon } from '@/shared/ui/Icon/Icon'
import {
  AccountCard as StyledAccountCard,
  AccountTitle,
  AccountDetails,
  AccountPath,
  AccountTop,
  AccountOption,
  AccountUser,
  AccountBottom,
  AccountCheck,
  TypeLabel,
  TypeText,
} from './styled'

export interface Account {
  id: string
  title: string
  username?: string
  path: string
  type: string
  objects: string
  status: string
}

export interface AccountCardProps {
  account: Account
  isSelected?: boolean
  onClick: (accountId: string) => void
}

export const AccountCard: React.FC<AccountCardProps> = ({
  account,
  isSelected = false,
  onClick,
}) => {
  return (
    <StyledAccountCard
      gap={16}
      vertical
      justify="space-between"
      onClick={() => onClick(account.id)}
      $isSelected={isSelected}
    >
      <AccountTop gap={16}>
        <AccountTitle strong>{account.title}</AccountTitle>
        <AccountCheck name="account_check" size={24} />
      </AccountTop>
      <AccountDetails vertical gap={8}>
        <AccountOption gap={8}>
          <Icon name="account_username" size={16} />
          <AccountUser>{account.username}</AccountUser>
        </AccountOption>
        <AccountOption gap={8}>
          <Icon name="account_path" size={16} />
          <AccountPath title={account.path}>{account.path}</AccountPath>
        </AccountOption>
      </AccountDetails>
      <AccountBottom justify="space-between" align="flex-end">
        <TypeLabel variant="accent">
          <TypeText content={account.type}>{account.type}</TypeText>
        </TypeLabel>
      </AccountBottom>
    </StyledAccountCard>
  )
}
